import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, RouteModel, EntityModel, ResponseDeleteModel, FileModel } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'
import { IImportService } from './api.app.service'

export interface IRoutesService extends IImportService {
    getRoutes(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    getRoutePoints(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    getRouteOperators(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    createRoute(req): ng.IPromise<RouteModel>
    getRoute(id, state?: any): ng.IPromise<RouteModel>
    getRouteToEdit(id, state?: any): ng.IPromise<EntityModel>
    getRouteFiles(id, state?: any): ng.IPromise<FileModel[]>
    deleteRoute(id): ng.IPromise<ResponseDeleteModel>
}

export class RoutesService implements IRoutesService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getRoutes(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.routes.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getRoutePoints(req: GridRequestModel, state: any = {}) {
        var getRoutePoints: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.routes['getRoutePoints']
        state.request = getRoutePoints(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
    getRouteOperators(req: GridRequestModel, state: any = {}) {
        var getRouteOperators: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.routes['getRouteOperators']
        state.request = getRouteOperators(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getRoute(id, state: any = {}) {
        var get = this.apiResource.routes.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    getRouteToEdit(id, state: any = {}) {
        var getRouteToEdit: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.routes['getRouteToEdit']
        state.request = getRouteToEdit({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getRouteFiles(id, state: any = {}) {
        var getRouteFiles = this.apiResource.routes['getRouteFiles']
        state.request = getRouteFiles({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
    
    createRoute(req): ng.IPromise<RouteModel> {
        return this.apiResource.routes.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    deleteRoute(id): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.routes.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    IsImportCompleted(model: GridModel) {
        return this.apiResource.routes['importIsCompleted'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getImportSummary(model: GridModel) {
        return this.apiResource.routes['importResume'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    initImport(model: GridModel) {
        return this.apiResource.routes['importInit'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    validateImport(guid: string) {
        return this.apiResource.routes['importValidate']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getImportData(guid: string) {
        return this.apiResource.routes['importGetData']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    startImport(guid: string) {
        return this.apiResource.routes['importStart']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    stopImport(guid: string) {
        return this.apiResource.routes['importStop']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    importProgress(guid: string) {
        return this.apiResource.routes['importProgress']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    importSummary(guid: string) {
        return this.apiResource.routes['importSummary']({ guid: guid }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }
}
